"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var validate = require("validate.js");
validate.extend(validate.validators.datetime, {
    parse: function (value, options) {
        return +moment.utc(value);
    },
    format: function (value, options) {
        var format = options.dateOnly ? "DD-MM-YYYY" : "YYYY-MM-DD hh:mm:ss";
        return moment.utc(value).format(format);
    }
});
exports.mandatory = {
    presence: { allowEmpty: false }
};
exports.email = {
    presence: { allowEmpty: false },
    email: true
};
exports.radioButton = {
    presence: { allowEmpty: false },
    inclusion: ["yes", "no"]
};
exports.money = {
    presence: { allowEmpty: false },
    numericality: {
        greaterThan: 0
    }
};
exports.date = {
    presence: { allowEmpty: false },
    datetime: {
        dateOnly: true,
        latest: moment.utc().year(3000),
        message: "Invalid date"
    }
};
exports.validateEmail = function (mail) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(mail);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbnMuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9saWIvZnVuY3Rpb25zL3ZhbGlkYXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsK0JBQWlDO0FBQ2pDLHNDQUF3QztBQUV4QyxRQUFRLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFO0lBRzFDLEtBQUssRUFBRSxVQUFVLEtBQUssRUFBRSxPQUFPO1FBQzNCLE9BQU8sQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQzdCLENBQUM7SUFFRCxNQUFNLEVBQUUsVUFBVSxLQUFLLEVBQUUsT0FBTztRQUM1QixJQUFJLE1BQU0sR0FBRyxPQUFPLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDLHFCQUFxQixDQUFBO1FBQ3BFLE9BQU8sTUFBTSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUE7SUFDM0MsQ0FBQztDQUNKLENBQUMsQ0FBQTtBQUVXLFFBQUEsU0FBUyxHQUFHO0lBQ3JCLFFBQVEsRUFBRSxFQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUM7Q0FDaEMsQ0FBQTtBQUVZLFFBQUEsS0FBSyxHQUFHO0lBQ2pCLFFBQVEsRUFBRSxFQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUM7SUFDN0IsS0FBSyxFQUFFLElBQUk7Q0FDZCxDQUFBO0FBRVksUUFBQSxXQUFXLEdBQUc7SUFDdkIsUUFBUSxFQUFFLEVBQUMsVUFBVSxFQUFFLEtBQUssRUFBQztJQUM3QixTQUFTLEVBQUUsQ0FBQyxLQUFLLEVBQUUsSUFBSSxDQUFDO0NBQzNCLENBQUE7QUFFWSxRQUFBLEtBQUssR0FBRztJQUNqQixRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFDO0lBQzdCLFlBQVksRUFBRTtRQUNWLFdBQVcsRUFBRSxDQUFDO0tBQ2pCO0NBQ0osQ0FBQTtBQUVZLFFBQUEsSUFBSSxHQUFHO0lBQ2hCLFFBQVEsRUFBRSxFQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUM7SUFDN0IsUUFBUSxFQUFFO1FBQ04sUUFBUSxFQUFFLElBQUk7UUFDZCxNQUFNLEVBQUUsTUFBTSxDQUFDLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUM7UUFDL0IsT0FBTyxFQUFFLGNBQWM7S0FDMUI7Q0FDSixDQUFBO0FBRVksUUFBQSxhQUFhLEdBQUcsVUFBQyxJQUFJO0lBQzlCLElBQU0sRUFBRSxHQUFHLDJKQUEySixDQUFBO0lBQ3RLLE9BQU8sRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQTtBQUN4QixDQUFDLENBQUEifQ==